import CreatableMultiSelectPicker from "components/CreatableMultiSelectPicker";
import Input from "components/Input";
import SingleSelectPicker from 'components/SingleSelectPicker';
import constants from 'constants.js';
import FeatherIcon from "feather-icons-react";
import {useButtonListener} from 'hooks/utils';
import {useState} from "react";
import {useForm} from "react-hook-form";
import {useFunctions} from "reactfire";
import {httpsCallable} from "firebase/functions";
import swal from "sweetalert";
import countries from 'data/countries.js'

export default function CreateClient({setIsOpen}) {
  const functions = useFunctions()
  const createUser = httpsCallable(functions, 'usersFunctions-create')
  const [isLoading, setIsLoading] = useState(false)

  const { register, handleSubmit, reset, control, formState } = useForm({
    defaultValues: {
      role: 'client'
    }
  })
  const { isDirty } = formState;

  const onSubmit = async (data) => {
    try {
      setIsLoading(true)
      await createUser(data)
      setIsLoading(false)
      await swal('Success', `Client created successfully`, 'success')
      reset()
      setIsOpen(false)
    } catch (err) {
      setIsLoading(false)
      await swal('Warning', err.message, 'warning')
    }
  }

  const handleCancel = (e) => {
    e?.preventDefault()
    if(isDirty && !confirm('Are you sure you want to cancel the edits you have made?')) {
      return;
    }
    reset();
    setIsOpen(false)
  }

  useButtonListener(handleCancel, 27, [formState])

  return(
    <div className={`modal h-modal is-big is-active`}>
      <div className="modal-background h-modal-close"/>
      <div className="modal-content">
        <form className="modal-card" onSubmit={handleSubmit(onSubmit)}>
          <header className="modal-card-head">
            <h3>Add Client</h3>
            <a href="#" className="h-modal-close ml-auto" aria-label="close" onClick={()=> setIsOpen(false)}>
              <FeatherIcon icon="x" />
            </a>
          </header>
          <div className="modal-card-body">
            <div className="inner-content">
              <div className="modal-form">
                <div className="columns is-multiline">
                  <Input label="Email" placeHolder="john@example.com" name="email" helper="Mandatory"
                         helperClass="help text-danger" register={register} validation={{required: true}}
                         options={{required: true}} />
                  <Input label="Display Name" placeHolder="John Doe" name="displayName" helper="Mandatory"
                         helperClass="help text-danger" register={register} validation={{required: true}}
                         options={{required: true}} />
                  <Input label="Name Abbreviation" placeHolder="Ex: JOE" name="abbreviation" helper="Mandatory"
                         helperClass="help text-danger" register={register} validation={{required: true}}
                         options={{required: true}} />
                  <Input label="Password" placeHolder="Insert password here" name="password" helper="Mandatory"
                         helperClass="help text-danger" register={register} validation={{required: true}}
                         options={{required: true}} />

                  <div className="column is-6">
                    <div className="field">
                      <label>Design Sizes</label>
                      <div className="control">
                        <CreatableMultiSelectPicker
                          name="design_sizes" dropdownDisabled={true} register={register} control={control}
                          args={{validation: {required: true}}} />
                      </div>
                      <p className="help text-info">Press enter after each design size</p>
                      <p className="help text-danger">Mandatory</p>
                    </div>
                  </div>

                  <div className="column is-6">
                    <div className="field">
                      <label>Country</label>
                      <div className="control">
                        <SingleSelectPicker options={countries}
                          name="country" register={register} control={control}
                          menuPlacement={'top'} />
                      </div>
                      <p className="help">Optional</p>
                    </div>
                  </div>

                  <div className="column is-6">
                    <div className="field">
                      <label>Category</label>
                      <div className="control">
                        <SingleSelectPicker
                          options={constants.CLIENTS_CATEGORIES.map(category => ({label: category, value: category}))}
                          name="category" register={register} control={control} menuPlacement={'top'}
                          args={{rules: {required: true}}} />
                      </div>
                      <p className="help text-danger">Mandatory</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-card-foot is-end">
            <a className={`button h-button is-rounded h-modal-close ${isLoading && 'is-loading'}`}
               onClick={handleCancel} type="reset">
              Cancel
            </a>
            <button className={`button h-button is-primary is-raised is-rounded ${isLoading && 'is-loading'}`}>
              Create
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
